import {
  SET_RESETMINED_TAB,
  SET_RESETLAB_TAB,
  SET_RESETFANCY_TAB,
  SET_RESETREQUEST_TAB,
  SET_COMPARE_TAB_IDS,
  SET_GEMSTONE_DETAILS,
  SET_SAVESEARCH_MINEDTAB,
  SET_SAVEFILTER_MINEDTAB,
  SET_SAVEEVERYTIME_MINEDTAB,
  SET_SWITCHFILTER_MINEDTAB,
  SET_COMPARE_PAGE_KEY,
  SET_RESETMINED_TOGGLE,
  SET_RESETLAB_TOGGLE,
  SET_RESETFANCY_TOGGLE,
} from "../../actions/selectyourgemstone/types";

const initialState = {
  resetMined: true,
  resetMinedToogle: true,
  resetLab: true,
  resetlabToogle: true,
  resetFancy: true,
  resetFancyToogle: true,
  resetRequest: true,

  saveSearchMined: false,
  minedGemStoneFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Certificate: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeMined: {},
  saveSearchLab: false,
  LabDiamondFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Certificate: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeLab: {},

  saveSearchFancy: false,
  FancyDiamondFilter: {
    Shape: [],
    Cut: [],
    Color: [],
    Clarity: [],
    Polish: [],
    Fluorescence: [],
    Symmetry: [],
    Intensity: [],
    Certificates: [],
    TableMin: 0,
    TableMax: 100,
    DepthMin: 0,
    DepthMax: 100,
    PriceMin: 0,
    PriceMax: 9999999,
    CaratMin: 0,
    CaratMax: 22,
    disabled: {},
  },
  everyTimeFilterChangeFancy: {},
  compareIds: [],
  compareKey: "",
  diamondDetails: {},
};

export default function handleHeader(
  SelectYourGemStoneState = initialState,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case SET_RESETMINED_TAB:
      return {
        ...SelectYourGemStoneState,
        resetMined: payload,
      };
    case SET_RESETMINED_TOGGLE:
      return {
        ...SelectYourGemStoneState,
        resetMinedToogle: !SelectYourGemStoneState.resetMinedToogle,
      };

    
    case SET_RESETLAB_TOGGLE:
      return {
        ...SelectYourGemStoneState,
        resetlabToogle: !SelectYourGemStoneState.resetlabToogle,
      };
   
    case SET_RESETFANCY_TOGGLE:
      return {
        ...SelectYourGemStoneState,
        resetFancyToogle: !SelectYourGemStoneState.resetFancyToogle,
      };

    case SET_RESETREQUEST_TAB:
      return {
        ...SelectYourGemStoneState,
        resetRequest: !SelectYourGemStoneState.resetRequest,
      };

    case SET_COMPARE_TAB_IDS:
      return {
        ...SelectYourGemStoneState,
        compareIds: payload,
      };
    case SET_GEMSTONE_DETAILS:
      return {
        ...SelectYourGemStoneState,
        diamondDetails: payload,
      };
    case SET_SAVESEARCH_MINEDTAB:
      return {
        ...SelectYourGemStoneState,
        saveSearchMined: payload,
      };
    case SET_SAVEFILTER_MINEDTAB:
      return {
        ...SelectYourGemStoneState,
        everyTimeFilterChangeMined: payload,
      };

    case SET_SAVEEVERYTIME_MINEDTAB:
      return {
        ...SelectYourGemStoneState,
        everyTimeFilterChangeMined: payload,
      };
    case SET_SWITCHFILTER_MINEDTAB:
      return {
        ...SelectYourGemStoneState,
        minedGemStoneFilter: SelectYourGemStoneState.everyTimeFilterChangeMined,
      };

    case SET_COMPARE_PAGE_KEY:
      return {
        ...SelectYourGemStoneState,
        compareKey: payload,
      };

    default:
      return SelectYourGemStoneState;
  }
}
